import React from 'react';
import {useTranslation} from "react-i18next";
import Button from "components/Button";
import { ReactComponent as ExternalLink } from 'assets/images/telegram.svg';

import ManticoreImage from "assets/images/manticore-card.png";

import useBotLink from "assets/hooks/useBotLink";
import c from './index.module.scss'

const LeftCard = ({mainTitle,subTitle, solutionTitle, list, MainIcon, isDottedList, subTitle2}) => {
    const { t } = useTranslation();
    const {link} = useBotLink()



    const handleOpenBot = () => {
        window.open(
            `tg://resolve?domain=${link}`,
            "_blank"
        );
    }

    return (
        <div className={c.card_wrapper} style={{
            background: `url(${ManticoreImage}) #F9F7FF no-repeat bottom`,
            backgroundPositionX: 'right',
            backgroundPositionY: 'bottom',
            backgroundSize: '60%'
        }}>
            {MainIcon &&
                <div style={{
                    margin: '0 0 12px 0'
                }}>
                    <MainIcon/>
                </div>
            }

            {solutionTitle &&
                <div className={c.solution_title}>
                    {solutionTitle}
                </div>
            }
            <div className={c.content}>
                {mainTitle &&
                    <h2 className={c.main_title}
                        dangerouslySetInnerHTML={{ __html: mainTitle }}
                    />
                }
                {subTitle &&
                    <p className={c.sub_title}>{subTitle}</p>
                }
                {subTitle2 &&
                    <p className={c.sub_title}>{subTitle2}</p>
                }
                {list &&
                    <ul className={`${c.list} ${isDottedList ? c.dotted_list : ''}`}>
                        {list?.map(({ icon: Icon, text }, index) => (
                            <li key={index}>
                                {Icon && <Icon />}
                                {text}
                            </li>
                        ))}
                    </ul>
                }
                <Button Icon={ExternalLink} text={t('default.buttonText')} onClick={handleOpenBot} />
            </div>
        </div>
    );
};

export default LeftCard;